export const phoneRegex = /^\+?(\d{1,4})?[-.\s]?(\d{1,3})?[-.\s]?(\d{2,4})[-.\s]?(\d{2,4})[-.\s]?(\d{2,9})$/;

export const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/;